<template>
  <div class="create-page">
    <div class="header">
      <h1>Add a shelf</h1>
    </div>
    <div class="content">
      <add-shelf-form></add-shelf-form>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import AddShelfForm from '../components/AddShelfForm';

export default {
  name: 'create',
  components: {
    'add-shelf-form': AddShelfForm,
  },
  data() {
    return {
      user: {},
      token: this.$cookies.get('user'),
      tags: [],
      shelflabel: '',
    };
  },
  methods: {
    getTags() {
      axios.get('/tags').then((response) => {
        this.tags = response.data.data;
      });
    },
    onSubmit() {
      axios
        .put(
          '/shelves',
          {
            tag: this.shelflabel,
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          },
        )
        .then(() => this.getShelves());
    },
  },
};
</script>
